
import { useTranslation } from 'react-i18next';

export default function MilestonesSection() {
  const { t } = useTranslation();

  const milestones = [
    {
      number: '200+',
      labelKey: 'creator_partners',
      labelEnKey: 'creator_partners_en',
      icon: 'ri-user-star-line',
      descKey: 'creator_partners_desc'
    },
    {
      number: '50+',
      labelKey: 'countries_regions',
      labelEnKey: 'countries_regions_en',
      icon: 'ri-global-line',
      descKey: 'countries_regions_desc'
    },
    {
      number: '24',
      labelKey: 'response_time',
      labelEnKey: 'response_time_en',
      icon: 'ri-time-line',
      descKey: 'response_time_desc'
    },
    {
      number: '98%',
      labelKey: 'client_satisfaction',
      labelEnKey: 'client_satisfaction_en',
      icon: 'ri-heart-line',
      descKey: 'client_satisfaction_desc'
    }
  ];

  const achievements = [
    {
      year: '2023',
      titleKey: 'year_2023',
      descKey: 'year_2023_desc'
    },
    {
      year: '2022',
      titleKey: 'year_2022',
      descKey: 'year_2022_desc'
    },
    {
      year: '2021',
      titleKey: 'year_2021',
      descKey: 'year_2021_desc'
    },
    {
      year: '2020',
      titleKey: 'year_2020',
      descKey: 'year_2020_desc'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('milestones_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('milestones_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('milestones_desc')}
          </p>
        </div>

        {/* 数据展示 */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {milestones.map((milestone, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${milestone.icon} text-white text-3xl`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
                {milestone.number}
              </div>
              <div className="text-gray-900 font-semibold mb-1">
                {t(milestone.labelKey)}
              </div>
              <div className="text-sm text-gray-500 mb-3">
                {t(milestone.labelEnKey)}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">
                {t(milestone.descKey)}
              </p>
            </div>
          ))}
        </div>

        {/* 发展历程 */}
        <div className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
            {t('development_history')}
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="text-2xl font-bold text-blue-600 mb-3">
                    {achievement.year}
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">
                    {t(achievement.titleKey)}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {t(achievement.descKey)}
                  </p>
                </div>
                {index < achievements.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-blue-600 to-purple-600 transform -translate-y-1/2"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
